import * as api from './adapter';

export default {

  index: async ({ search, type, ...rest }) => {
    const { data } = await api.read('select_options', {
      query: {
        q: search,
        type,
        ...rest,
      },
    });

    return data;
  },

  /**
   * resolve
   * Names for filter values restored from a URL — the URL carries ids only
   * (CREW-1169), and the option lists only hold the first 30 records, so a
   * picked owner further down the alphabet can be named by id alone
   * (CREW-1209).
   *
   * One request for every type at once. The backend decides the label per
   * type, so a chip cannot end up naming a record differently from the
   * dropdown it was picked from.
   *
   * @param {Array<{type: String, ids: Array<String>}>} batch
   * @returns {Promise<Object>} {backendType: [{value, label}]}
   */
  resolve: async (batch) => {
    // Content type goes in the THIRD argument, not inside `options`:
    // `apiRequest` merges options shallowly (`{...defaultOptions, ...options}`),
    // so an `options.headers` replaces the default header object wholesale and
    // takes the auth tokens with it — the request then answers 401.
    const { data } = await api.apiRequest(
      '/api/select_options/resolve',
      { method: 'POST', body: JSON.stringify({ batch }) },
      { 'Content-Type': 'application/json' },
    );

    return data;
  },
};
